
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/sap-ibp",
      function () {
        return require("private-next-pages/destinations/sap-ibp.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/sap-ibp"])
      });
    }
  